import gql from 'graphql-tag';
import { actionGQLFields } from '../common/action.fields.js';
import { appPublicationGQLFields, } from './appPublication.fields.js';
export const globalAppPublicationsQuery = (fields) => gql `
  query globalAppPublications($appId: ID!) {
    globalAppPublications(appId: $appId) {
      ${appPublicationGQLFields(fields)}
    }
  }
`;
export const globalPublishAppPrivatelyGQLMutation = (fields) => gql `
  mutation globalPublishAppPrivately($appId: ID!, $networkId: ID!) {
    globalPublishAppPrivately(appId: $appId, networkId: $networkId) {
      ${appPublicationGQLFields(fields)}
    }
  }
`;
export const globalUnPublishAppPrivatelyGQLMutation = (fields) => gql `
  mutation globalUnPublishAppPrivately($appId: ID!, $networkId: ID!) {
    globalUnPublishAppPrivately(appId: $appId, networkId: $networkId) {
      ${actionGQLFields(fields)}
    }
  }
`;
